// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"fF-z","smallCardRow":"gF-z","largeCardRow":"hF-z","productSearchRow":"iF-z","curatedRow":"jF-z"};